
import Vue from 'vue';
import { ClientConstants}  from '../client.constants';

export default Vue.extend({
    name: 'InfoWeCalculated',

    props: {
        id: String,
        title: String,
        federalTax: Object,
        stateTax: Object,
    },

    data: () => {
        return {
            clientConstants: ClientConstants,
        }
    },

    computed: {
        federalTaxRate(): string {
            return (this.federalTax !== undefined) && (this.federalTax.rate !== undefined)
                ? (100 * this.federalTax.rate).toFixed(2) + '%'
                : '';
        },
        federalTaxYear(): string {
            return (this.federalTax !== undefined) && (this.federalTax.rate !== undefined)
                ? '(' + this.federalTax.year + ')'
                : '';
        },
        stateTaxRate(): string {
            return (this.stateTax !== undefined) && (this.stateTax.rate !== undefined)
                ? (100 * this.stateTax.rate).toFixed(3) + '%'
                : '';
        },
        stateTaxYear(): string {
            return (this.stateTax !== undefined) && (this.stateTax.rate !== undefined)
                ? '(' + this.stateTax.year + ')'
                : '';
        },
    }
});
